import { useEffect } from "react";
import { useMemo } from "react";
import { useState } from "react";

const SettingGroup = ({
    _id,
    settingGroup,
    validator,
    update,
    renderActionButton,
    permissions
}) => {
    const [currentName, setCurrentName] = useState(settingGroup.name);
    const [currentSequence, setCurrentSequence] = useState(settingGroup.sequence);
    const [currentDescription, setCurrentDescription] = useState(settingGroup.description);

    const renderName = useMemo(() => {
        return (
            <input disabled={!permissions.update || !settingGroup.editable} type="string" className={`form-control form-control-sm px-2 py-1 ${currentName.length === 0 ? 'border-danger' : ''}`} value={currentName} onInput={(event) => update({ fieldType: "SettingGroup", newValue: event.target.value, initialValue: settingGroup.name, changedField: "name", _id, setterFunc: setCurrentName })} />
        );
    }, [_id, currentName, permissions.update, settingGroup.editable, settingGroup.name, update]);

    const renderSequence = useMemo(() => {
        return (
            <input disabled={!permissions.update || !settingGroup.editable} type="number" className="form-control form-control-sm px-2 py-1" value={currentSequence} onInput={(event) => update({ fieldType: "SettingGroup", newValue: event.target.value, initialValue: settingGroup.sequence, changedField: "sequence", _id, setterFunc: setCurrentSequence })} />
        );
    }, [_id, currentSequence, permissions.update, settingGroup.editable, settingGroup.sequence, update])

    const renderDescription = useMemo(() => {
        return (
            <input type="string" disabled={!permissions.update || !settingGroup.editable}
                className="form-control form-control-sm px-2 py-1"
                onInput={(event) => update({ _id, initialValue: settingGroup.description, fieldType: "SettingGroup", newValue: event.target.value, changedField: "description", setterFunc: setCurrentDescription })}
                value={currentDescription} />
        );
    }, [_id, currentDescription, permissions.update, settingGroup.description, settingGroup.editable, update]);

    useEffect(() => {
        (typeof currentName === "string") && validator({ _id, field: 'name', fieldValid: currentName.trim().length > 0 });
    }, [_id, currentName, validator]);

    return (
        <>
            <div className="col-fixed-5">
                {renderSequence}
            </div>
            <div className="col">
                {renderName}
            </div>
            <div className="col">
                {renderDescription}
            </div>
            <div className="col-fixed-5 d-flex justify-content-end">
                {
                    settingGroup.editable && permissions.update &&
                    renderActionButton({ actionType: 'delete', fieldType: "SettingGroup", _id })
                }
            </div>
        </>
    )
};

export default SettingGroup;